/* eslint-disable max-len */

import React from "react";
import ReactPlayer from "react-player";

import { Icon } from "../../components";
import { colors } from "../../styles";
import styles from "./styles";

const width = 640;
const height = 360;

class Events extends React.Component {
  state = {
    loading: true,
  };

  render() {
    return (
      <div style={{ ...styles.container, ...this.props.style, position: "relative" }}>
        <h1 style={styles.h1}>Blogs</h1>
        <a
          style={styles.mediaLink}
          href="https://blog.sportslaw.org/posts/peeling-back-the-onion-sports-production-during-a-pandemic/ "
        >
          Peeling Back the Onion: Sports Production During a Pandemic
        </a>
        <a
          style={styles.mediaLink}
          href="https://blog.sportslaw.org/posts/new-definitions-in-the-media-landscape/  "
        >
          New Definitions in the Media Landscape
        </a>
        <h1 style={styles.h1}>Podcasts & Speaking Engagements</h1>
        <div style={{ height: 24 }} />
        {this.state.loading && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height,
              width,
              background: colors.opaqueBlack,
            }}
          >
            <Icon name="dots" />
          </div>
        )}
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://youtu.be/tpSCj84QJck"
          playing
        />
        <div style={{ height: 24 }} />
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://youtu.be/jqlXY3GAxio"
        />
        <div style={{ height: 24 }} />
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://soundcloud.com/mteinstein/contracting-in-the-age-of-coronavirus"
        />
        <div style={{ height: 24 }} />
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://soundcloud.com/mteinstein/name-image-and-likeness-and-the-future-of-college-sports"
        />
        <div style={{ height: 24 }} />
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://soundcloud.com/mteinstein/bobby-hacker-speaker-sequence"
        />
        {/* <div style={{ height: 24 }} /> */}
        {/* <blockquote class="twitter-tweet" data-lang="en"><p lang="en" dir="ltr">Welcome to the June Member in the Spotlight. This month we would like to introduce you to Bobby Hacker, SLA President. <a href="https://twitter.com/hashtag/sportslawyers?src=hash&amp;ref_src=twsrc%5Etfw">#sportslawyers</a> <a href="https://twitter.com/hashtag/memberinthespotlight?src=hash&amp;ref_src=twsrc%5Etfw">#memberinthespotlight</a> <a href="https://twitter.com/hashtag/SLAinfluencers?src=hash&amp;ref_src=twsrc%5Etfw">#SLAinfluencers</a> <a href="https://twitter.com/hashtag/SLAleaders?src=hash&amp;ref_src=twsrc%5Etfw">#SLAleaders</a><a href="https://t.co/GCydoGKp2Q">https://t.co/GCydoGKp2Q</a> <a href="https://t.co/nocUUdZ590">pic.twitter.com/nocUUdZ590</a></p>&mdash; Sports Lawyers Assn. (@sportslawyers) <a href="https://twitter.com/sportslawyers/status/1141387747233603586?ref_src=twsrc%5Etfw">June 19, 2019</a></blockquote> */}
        <div style={{ height: 24 }} />
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://soundcloud.com/user-781395898/episode-10-game-on-introduction-to-esports"
        />
        <div style={{ height: 24 }} />
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://soundcloud.com/mteinstein/sla-then-now-and-tomorrow"
        />
        <div style={{ height: 24 }} />
        <ReactPlayer
          width={this.state.loading ? 0 : width}
          height={this.state.loading ? 0 : height}
          onReady={() => this.setState({ loading: false })}
          url="https://soundcloud.com/lawinsport/the-art-of-million-dollar-sports-media-rights-deals-an-interview-with-bobby-hacker"
        />
        <div style={{ height: 24 }} />
      </div>
    );
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/views/Media/index.js